import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-table-plans-component',
  templateUrl: './table-plans-component.component.html',
  styleUrls: ['./table-plans-component.component.scss']
})
export class TablePlansComponentComponent implements OnInit {

  @Input() plans: object;
  @Input() typePlans: object;

  planStatusName = {
    1: `<span class="badge badge-success">Ativo</span>`,
    2: `<span class="badge badge-secondary">Vencido</span>`,
    3: `<span class="badge badge-danger">Cancelado</span>`,
    4: `<span class="badge badge-warning">Aguardando Pagamento</span>`
  }

  nome

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.nome = this.userService.getName()
  }

  getPlanName (type) {
    const plans = this.typePlans['plans']
    if (plans) {
      const plan = plans.filter((item) => { return item.id === type })
      return plan[0].name
    }
  }

  formatDate (dateInput) {
    if (dateInput) {
      return moment(dateInput).format('DD/MM/YYYY')
    } else {
      return 'Recorrente'
    }
  }

  checkStatus (status) {
    return this.planStatusName[status]
  }

  pagarPlano (planId) {
    this.router.navigateByUrl('/logado/pagar-plano?plan_id=' + planId)
  }

  msgCancelPlan() {
    return 'Olá, sou o ' + this.nome + ' e desejo cancelar meu plano.'
  }
}
